// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "common" + "." + "21382d23b1be358dc47f" + ".css";
};